(function() {
  'use strict';

  angular
    .module('chosen2', ['ui.router', 'ui.bootstrap', 'toastr', 'chart.js', 'timer', 'ngAudio','angularSpinner']);

})();

(function () {
  'use strict';

  angular
    .module('chosen2')
    .factory('AuthFactory', AuthFactory);

  /** @ngInject */
  function AuthFactory($http) {
    var users = [];
    var currentUser = null;
    var userVerified = false;
    var getUserVerified = function () {
      return userVerified;
    }
    var setUserVerified = function (value) {
      userVerified = value;
    }
    var userRole = null;
    var getUsers = function () {
      $http.get('assets/data/users.json').
        success(function (Data, status, headers, config) {
          users = Data.users;
        }).
        error(function (data, status, headers, config) {
          // log error
        });
    };
    getUsers();
    var verifyUser = function (email, password) {
      for (var x = 0; x < users.length; x++) {
        if (users[x].email == email && users[x].password == password) {
          userVerified = true;
          currentUser = users[x];
        }
      }
      return userVerified;
    };
    return {
      "verifyUser": verifyUser,
      "getUserVerified": getUserVerified,
      "setUserVerified": setUserVerified
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('chosen2')
    .controller('AuthController', AuthController);

  /** @ngInject */
  function AuthController(AuthFactory, $state) {
    var vm = this;
    vm.email = "";
    vm.password = "";
    vm.userVerified = true;
    vm.login = function () {
      vm.userVerified = AuthFactory.verifyUser(vm.email, vm.password);
      AuthFactory.setUserVerified(vm.userVerified);
      if (vm.userVerified) {
        $state.go('assessment');
      }
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('chosen2')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $log, $timeout, ngAudio, $interval, $q, $http, AuthFactory, $state) {
    var vm = this;
    var data = null;
    var totalAudioFilesToLoad = 0;
    var deferredLoadData = $q.defer();
    vm.showSpinner = true;

    var init = function () {
      vm.data = data;
      vm.currentQuestionIndex = 0;
      vm.currentAssessmentIndex = 0;
      vm.selectedAnswerCategory = null;
      vm.selectedAnswerScore = 0;
      vm.graphData = [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0]];
      vm.tabActive = [];
      vm.isAssessmentEnded = false;
      vm.showSpinner = false;
      //Play first track
      vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].audio.object.play();

    };
    var audioFileDownloaded = function (promise) {
      $interval.cancel(promise);
      totalAudioFilesToLoad--;
      if (totalAudioFilesToLoad == 0) {
        deferredLoadData.resolve();
      }
    }
    var loadData = function () {

      $http.get('assets/data/data.json').
        success(function (Data, status, headers, config) {
          data = Data;
          for (var y = 0; y < data.assessments.length; y++) {
            //Loading assessment audio files.
            for (var x = 0; x < data.assessments[y].questions.length; x++) {
              totalAudioFilesToLoad++;
              var audioFile = null;
              audioFile = ngAudio.load('assets/audio/' + data.assessments[y].questions[x].audio.filename); // returns
              // NgAudioObject
              data.assessments[y].questions[x].audio.object = audioFile;
              (function (audioFile, y, x) {
                var promise = $interval(function () {
                  if ('duration' in audioFile && !isNaN(audioFile.duration)) {
                    data.assessments[y].questions[x].question_time = audioFile.duration;
                    audioFileDownloaded(promise);
                  }
                });
              })(audioFile, y, x);
            }
          }
        }).
        error(function (data, status, headers, config) {
          // log error
        });
    };
    deferredLoadData.promise.then(function () {
      init();
    });

    //Start loading data.
    if(AuthFactory.getUserVerified()) {
      loadData();
      AuthFactory.setUserVerified(false);
    }
    else {
      $state.go("auth");
    }


    vm.onClickSelectedStatement = function (category, statement) {
      vm.selectedAnswerCategory = category;
      $scope.$broadcast('timer-stop');
      //Stop playing audio
      vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].audio.object.stop();
      vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].selected.statement = statement;
    };

    vm.onClickSelectedAnswer = function (score, option) {
      if (vm.data.assessments[vm.currentAssessmentIndex].questions.length > vm.currentQuestionIndex) {
        vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].audio.object.stop();
        if (score !== false) {
          vm.selectedAnswerScore = score;
          var catGryIndex = vm.getCategoryIndex(vm.selectedAnswerCategory);
          vm.addGraphData(catGryIndex, vm.selectedAnswerScore);
          vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].selected.option = option;
          vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].selected.score = vm.selectedAnswerScore;
          vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].selected.category = vm.selectedAnswerCategory;
          vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].audio.object.stop();

        }
        //Next question
        vm.selectedAnswerCategory = null;
        vm.selectedAnswerScore = 0;

        if (vm.data.assessments[vm.currentAssessmentIndex].questions.length > vm.currentQuestionIndex + 1) {
          vm.currentQuestionIndex = vm.currentQuestionIndex + 1;
          //Start Timer Again
          $timeout(function () {
            $scope.$broadcast('timer-start');
            $scope.$broadcast('timer-set-countdown', vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].question_time);
            $scope.$apply();
            //Play next question
            vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].audio.object.play();

          });
        }
        else {
          if (vm.currentAssessmentIndex == 0) {
            vm.tabActive[0] = false;
            vm.tabActive[1] = true;
            vm.currentQuestionIndex = 0;
            vm.currentAssessmentIndex = 1;
            $log.log('questions ended.move to next assessment');

            //Start timer again
            $timeout(function () {
              $scope.$broadcast('timer-start');
              $scope.$broadcast('timer-set-countdown', vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].question_time);
              $scope.$apply();
              //Play next question
              vm.data.assessments[vm.currentAssessmentIndex].questions[vm.currentQuestionIndex].audio.object.play();
            });
          }
          else {
            $log.log('Assessment ended');
            vm.isAssessmentEnded = true;
          }
        }
      }

    };

    vm.getCategoryIndex = function (category) {
      for (var x = 0; x < vm.data.assessments[vm.currentAssessmentIndex].categories.length; x++) {
        if (category == vm.data.assessments[vm.currentAssessmentIndex].categories[x])
          return x;
      }
    };

    vm.addGraphData = function (index, score) {
      vm.graphData[vm.currentAssessmentIndex][index] = vm.graphData[vm.currentAssessmentIndex][index] + score;
    };

    vm.numToChar = function (n) {
      return String.fromCharCode(97 + n);
    };


  }
})();
(function() {
  'use strict';

  angular
    .module('chosen2')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('chosen2')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('assessment', {
        url: '/assessment',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        resolve: {

        }
      })
      .state('auth', {
        url: '/',
        templateUrl: 'app/components/auth/auth.html',
        controller: 'AuthController',
        controllerAs: 'auth',
        resolve: {
        }
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('chosen2')

})();

(function() {
  'use strict';

  angular
    .module('chosen2')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("chosen2").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div class=\"row\"><span us-spinner=\"\" spinner-on=\"main.showSpinner\"></span></div><div class=\"row\" ng-hide=\"main.showSpinner\"><div class=\"col-md-12\"><div class=\"page-header\"><h1>Assessment System</h1></div><div ng-if=\"main.isAssessmentEnded\"><h3>Result</h3><div ng-repeat=\"assessment in main.data.assessments\" class=\"clearfix\"><div class=\"text-center bg-info pd15\"><h5>{{assessment.name}}</h5></div><div><table class=\"table table-striped\"><thead><tr><th>Question #</th><th>Selected Statement</th><th>Score</th><th>Category</th></tr></thead><tbody><tr ng-repeat=\"question in assessment.questions\"><td>{{question.id}}</td><td ng-if=\"question.selected.statement !=null\">{{question.selected.statement}}</td><td ng-if=\"question.selected.statement ==null\">Statement not selected</td><td ng-if=\"question.selected.score !=null\">{{question.selected.score}}</td><td ng-if=\"question.selected.score ==null\">Score not calculated</td><td ng-if=\"question.selected.category !=null\">{{question.selected.category}}</td><td ng-if=\"question.selected.category ==null\">Category not selected</td></tr></tbody></table></div><div class=\"bar-graph col-md-6 col-md-offset-3\"><canvas class=\"chart chart-bar\" chart-data=\"[main.graphData[$index]]\" chart-labels=\"assessment.categories\"></canvas></div></div></div><uib-tabset justified=\"true\" ng-if=\"!main.isAssessmentEnded\"><uib-tab heading=\"{{assessments.name}}\" disable=\"true\" active=\"main.tabActive[$index]\" ng-repeat=\"assessments in main.data.assessments\"><div class=\"assessment-content\"><p class=\"bg-info pd20 mg-top25\"><u>Directions:</u>You will be given two (2) statements (A and B). Choose between the two statements which one is most like you. There will be times when neither statement describes you. Leave that question blank. When both statements describe you, choose between the two which describes you best.</p><div class=\"panel panel-success mg-top25\"><div class=\"panel-heading text-center\"><b>Assessment Name: {{assessments.name}}</b></div><div class=\"panel-body\"><div class=\"question-content\"><div class=\"row\"><div class=\"h4 col-md-12\" ng-show=\"main.selectedAnswerCategory == null\"><button type=\"button\" ng-if=\"(main.data.assessments[main.currentAssessmentIndex].questions.length > main.currentQuestionIndex + 1)\" ng-click=\"main.onClickSelectedAnswer(false)\" class=\"btn btn-warning pull-right\">Skip statement</button> <button type=\"button\" ng-if=\"!(main.data.assessments[main.currentAssessmentIndex].questions.length > main.currentQuestionIndex + 1)\" ng-click=\"main.onClickSelectedAnswer(false)\" class=\"btn btn-danger pull-right\"><span ng-show=\"main.currentAssessmentIndex == 0\">Next Assessment</span> <span ng-show=\"main.currentAssessmentIndex == 1\">End Assessment</span></button></div></div><div class=\"row\"><div class=\"h4 col-md-12 text-info\">Select one statement if it suits you else skip it.</div></div><div class=\"row\"><div class=\"col-md-12\"><timer countdown=\"main.data.assessments[main.currentAssessmentIndex].questions[main.currentQuestionIndex].question_time\" finish-callback=\"main.onClickSelectedAnswer(false)\" interval=\"1000\"><div class=\"h5 text-center\" ng-class=\"{\'bg-danger\':seconds<=4}\"><strong>Time left for this question: <span>{{seconds}} second{{secondsS}}</span></strong></div></timer></div></div><div ng-repeat=\"questions in assessments.questions\"><div ng-show=\"$index == main.currentQuestionIndex\"><div class=\"question-statements\" ng-repeat=\"question in questions.question\"><span>Statement {{main.numToChar($index) | uppercase}}</span> <button type=\"button\" ng-click=\"main.onClickSelectedStatement(question.category,question.statement)\" ng-class=\"{\'active btn-success\': question.category == main.selectedAnswerCategory}\" ng-disabled=\"main.selectedAnswerCategory != null\" class=\"btn btn-primary btn-block mg-top10\">{{question.statement}}</button></div><div ng-show=\"main.selectedAnswerCategory != null\"><div class=\"h4\">Options</div><div class=\"question-answers\" ng-repeat=\"answer in questions.answer\"><button type=\"button\" ng-click=\"main.onClickSelectedAnswer(answer.score,answer.statement)\" class=\"btn btn-primary btn-block mg-top10\">{{answer.statement}}</button></div></div><hr></div></div><div class=\"h3\">Assessment Graph</div><div class=\"bar-graph col-md-6 col-md-offset-3\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"[main.graphData[main.currentAssessmentIndex]]\" chart-labels=\"assessments.categories\"></canvas></div></div></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/components/auth/auth.html","<div class=\"container-fluid auth\"><div class=\"row\"><div class=\"cover\"><img src=\"assets/images/login.jpg\"></div><div class=\"login col-md-offset-4 col-md-4\"><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Please enter your credentials</h3></div><div class=\"panel-body\"><form><div class=\"input-group form-group\"><span class=\"input-group-addon\" id=\"email\">@</span> <input type=\"email\" class=\"form-control\" ng-model=\"auth.email\" placeholder=\"Email\" aria-describedby=\"basic-addon1\" required=\"\"></div><div class=\"input-group form-group\"><span class=\"input-group-addon\" id=\"pass\">*</span> <input type=\"password\" class=\"form-control\" ng-model=\"auth.password\" placeholder=\"Password\" aria-describedby=\"basic-addon1\" required=\"\"></div><div class=\"input-group form-group pull-right\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"auth.login()\">Sign in</button></div><p class=\"text-danger\" ng-hide=\"auth.userVerified\">Incorrect username or password</p></form></div></div></div></div></div>");}]);